import {create} from "zustand";
import { ISnowflakeEventData,
    IAdoptEaseConfig,
    IAdoptEaseUsage,
    ISnowflakeDMSFunctionCalls,
    IAdoptEaseWorkflow,
    ISnowflakeWorkflowUsageThroughDWM,
    ISnowflakeTraining,
    INeverUsedApp } from '../types';

export interface AdoptEaseState {
    snowflakeEventData: ISnowflakeEventData[];
    setSnowflakeEventData: (snowflakeEventData:ISnowflakeEventData[]) => void;
    adoptEaseConfigData: IAdoptEaseConfig[];
    setAdoptEaseConfigData: (adoptEaseConfigData:IAdoptEaseConfig[]) => void;
    adoptEaseUsageData: IAdoptEaseUsage[];
    setAdoptEaseUsageData: (adoptEaseUsageData:IAdoptEaseUsage[]) => void;
    snowflakeDMSFunctionCallsData: ISnowflakeDMSFunctionCalls[];
    setSnowflakeDMSFunctionCallsData: (snowflakeDMSFunctionCallsData:ISnowflakeDMSFunctionCalls[]) => void;
    adoptEaseWorkflows: IAdoptEaseWorkflow[];
    setIAdoptEaseWorkflows: (adoptEaseWorkflows:IAdoptEaseWorkflow[]) => void;
    workflowUsageThroughDWM: ISnowflakeWorkflowUsageThroughDWM[];
    setWorkflowUsageThroughDWM: (workflowUsageThroughDWM:ISnowflakeWorkflowUsageThroughDWM[]) => void;
    snowflakeApplicationData: ISnowflakeEventData[];
    setSnowflakeApplicationData: (snowflakeApplicationData:ISnowflakeEventData[]) => void;
    trainingData: ISnowflakeTraining[];
    setTrainingData: (trainingData:ISnowflakeTraining[]) => void;
    enableAdopteaseApps: boolean;
    setEnableAdopteaseApps: (enableAdopteaseApps:boolean) => void;
    neverUsedApps: INeverUsedApp[];
    setNeverUsedApps: (neverUsedApps: INeverUsedApp[]) => void;
  }
  
export const useAdoptEaseStore = create<AdoptEaseState>((set) => ({
    snowflakeEventData: [],
    setSnowflakeEventData: (snowflakeEventData) => set(() => ({ snowflakeEventData })),
    adoptEaseConfigData: [],
    setAdoptEaseConfigData: (adoptEaseConfigData) => set(() => ({ adoptEaseConfigData })),
    adoptEaseUsageData: [],
    setAdoptEaseUsageData: (adoptEaseUsageData) => set(() => ({ adoptEaseUsageData })),
    snowflakeDMSFunctionCallsData: [],
    setSnowflakeDMSFunctionCallsData: (snowflakeDMSFunctionCallsData) => set(() => ({ snowflakeDMSFunctionCallsData })),
    adoptEaseWorkflows: [],
    setIAdoptEaseWorkflows: (adoptEaseWorkflows) => set(() => ({ adoptEaseWorkflows })),
    workflowUsageThroughDWM: [],
    setWorkflowUsageThroughDWM: (workflowUsageThroughDWM) => set(() => ({ workflowUsageThroughDWM })),
    snowflakeApplicationData: [],
    setSnowflakeApplicationData: (snowflakeApplicationData) => set(() => ({ snowflakeApplicationData })),
    trainingData: [],
    setTrainingData: (trainingData) => set(() => ({ trainingData })),
    enableAdopteaseApps: false,
    setEnableAdopteaseApps: (enableAdopteaseApps) => set(() => ({ enableAdopteaseApps })),
    neverUsedApps: [],
    setNeverUsedApps: (neverUsedApps) => set(() => ({ neverUsedApps })),
 }));


